// extracted by mini-css-extract-plugin
module.exports = {"paper":"Paper_paper__pjdE3","elevation-1":"Paper_elevation-1__eW6Q6","elevation-2":"Paper_elevation-2__k52_K"};